// draggableFixedSize.js (不允许改变大小)
export const draggableFixedSize = {
    mounted(el) {
      let isDragging = false;
      let offsetX = 0;
      let offsetY = 0;
  
      // 获取并固定元素的初始大小
      const initialWidth = el.offsetWidth;
      const initialHeight = el.offsetHeight;
      el.style.width = `${initialWidth}px`;
      el.style.height = `${initialHeight}px`;
  
      // 鼠标按下时，开始拖动
      el.addEventListener('mousedown', (e) => {
        isDragging = true;
        offsetX = e.clientX - el.offsetLeft;
        offsetY = e.clientY - el.offsetTop;
        document.body.style.userSelect = 'none'; // 防止选中文本
      });
  
      // 鼠标移动时，拖动元素
      document.addEventListener('mousemove', (e) => {
        if (isDragging) {
          el.style.left = `${e.clientX - offsetX}px`;
          el.style.top = `${e.clientY - offsetY}px`;
        }
      });
  
      // 鼠标松开时，停止拖动
      document.addEventListener('mouseup', () => {
        isDragging = false;
        document.body.style.userSelect = ''; // 恢复选中文本
      });
    }
  };
  